/* fw-footer-franchise-show-20260611_052603 */
(function(){
  function showFranchise(){
    document.querySelectorAll('.footer-nx__franchise a[href*="franchise-info"], .footer-nx__franchise a[href*="franchise"]').forEach(function(a){
      var li=a.closest('li');
      if(li){ li.style.setProperty('display','list-item','important'); li.style.setProperty('visibility','visible','important'); li.style.setProperty('opacity','1','important'); }
      a.style.setProperty('display','inline','important');
      a.style.setProperty('visibility','visible','important');
      a.style.setProperty('opacity','1','important');
      a.style.setProperty('color','#fff','important');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',showFranchise); else showFranchise();
  setTimeout(showFranchise,300); setTimeout(showFranchise,1200); setTimeout(showFranchise,2500);
})();
